import SearchInput from 'shared/Inputs/SearchInput'
import { SelectOption } from 'shared/Inputs/Select'
import { useRecoilState } from 'recoil'
import gradeTableAtom from '../gradeTable/grade.atom'
import MultiSelect from 'shared/Inputs/Select/MultiSelect'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import { useEffect, useState } from 'react'
import protectionsApi from 'screens/Protection/protection.api'
import { IExpert } from 'screens/Protection/protection.types'

const GradeFilters = () => {
  const [state, setState] = useRecoilState(gradeTableAtom)
  const { wait } = useHttpLoader()
  const [expertOptions, setExpertOptions] = useState<SelectOption[]>([])

  useEffect(() => {
    wait(protectionsApi.getExperts({ limit: '1000' }), (resp) => {
      if (resp.status != 'success') return

      const options = resp.body?.items?.map((expert: IExpert) => ({
        value: expert.id,
        label: expert.info?.name,
      }))
      setExpertOptions(options)
    })
  }, [])

  const handleChange = (value: any, name: string) => {
    setState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [name]: value,
      },
    }))
  }

  const handleMultiSelectChange = (values: SelectOption[], name: string) => {
    setState((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [name]: values,
      },
    }))
  }

  const selectedExperts = (state.filters.expertIds as SelectOption[]) || []

  return (
    <div className='inline-flex-gap' style={{ gap: '8px' }}>
      <SearchInput
        value={state.filters.search}
        name='search'
        onChange={handleChange}
        required={false}
        placeholder='Поиск'
        autofocus={true}
      />

      <div
        style={{
          width: '300px',
          flex: '0 0 300px',
        }}
      >
        <MultiSelect
          name='expertIds'
          options={expertOptions}
          selectedOptions={selectedExperts}
          onChange={handleMultiSelectChange}
          placeholder='Выберите экспертов...'
        />
      </div>
    </div>
  )
}

export default GradeFilters
